import { Component, OnInit, Inject } from '@angular/core';
import { LoginMessage } from '@model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-login-message',
    templateUrl: './login-message.component.html',
    standalone: false
})
export class LoginMessageComponent implements OnInit {
  loginMessage: LoginMessage;

  constructor(public dialogRef: MatDialogRef<LoginMessageComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit() {
    // Clone the object
    this.loginMessage = { ...this.data };
  }

  onCancel() {
    this.dialogRef.close();
  }
}
